import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcCategory(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.775 19.274a.75.75 0 0 1 0 1.492l-.076.004H1.754a.75.75 0 0 1 0-1.5h12.945zM14.698 3.35a6.73 6.73 0 0 1 6.732 6.731 6.7 6.7 0 0 1-1.473 4.199l3.269 3.268.051.058a.75.75 0 0 1-1.054 1.054l-.058-.051-3.268-3.269a6.7 6.7 0 0 1-4.199 1.473 6.732 6.732 0 0 1 0-13.463m0 1.5a5.232 5.232 0 1 0 0 10.463 5.232 5.232 0 0 0 0-10.463m-8.55 7.924a.75.75 0 0 1 0 1.492l-.078.004H1.75a.75.75 0 0 1 0-1.5h4.32zm0-6.5a.75.75 0 0 1 0 1.492l-.078.004H1.75a.75.75 0 0 1 0-1.5h4.32z"
  }));
}
var IcCategory = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCategory));

export { IcCategory as I };
